import React from "react";
import { Box, Container, Typography, Grid, Card, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

function Services() {

  const navigate = useNavigate();

  const services = [
    {
      title: "Construction",
      desc: "Complete residential and commercial construction solutions.",
      path: "/services/construction"
    },
    {
      title: "Architecture",
      desc: "Modern architectural planning and structural design.",
      path: "/services/architecture"
    },
    {
      title: "Interior Design",
      desc: "Creative interior solutions for modern homes.",
      path: "/services/interior"
    }
  ];

  return (
    <Box sx={{ py: 10, background: "#f7f7ff" }}>
      <Container>

        <Typography
          variant="h4"
          textAlign="center"
          fontWeight="bold"
          mb={6}
        >
          Our Services
        </Typography>

        <Grid container spacing={4}>

          {services.map((service, index) => (
            <Grid item xs={12} md={4} key={index}>

              <Card
                sx={{
                  p: 4,
                  borderRadius: 4,
                  textAlign: "center",
                  transition: "0.4s",

                  "&:hover": {
                    transform: "translateY(-10px)",
                    boxShadow: 6
                  }
                }}
              >

                <Typography variant="h6" fontWeight="bold">
                  {service.title}
                </Typography>

                <Typography sx={{ mt: 2 }}>
                  {service.desc}
                </Typography>

                <Button
                  variant="contained"
                  sx={{ mt: 3, background: "#0d0651" }}
                  onClick={() => navigate(service.path)}
                >
                  Learn More
                </Button>

              </Card>

            </Grid>
          ))}

        </Grid>

      </Container>
    </Box>
  );
}

export default Services;